module.exports = __webpack_public_path__ + "img/med-avatar7.ec88a375.png";